import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Account from "../../../Services/accountServices";
import USDFigure from "../../../Components/USDFigure";
import ExportComponents from "../../../Components/ExportComponents";
import Loader from "../../../Components/Loader";
import TitleHeader from "../Components/TitleHeader";

function AccountQuickReport(props) {
  const { accountId } = useParams();
  const [reports, setReports] = useState([]);
  const [startDate, setStartDate] = useState(
    `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`
  );
  const [endDate, setEndDate] = useState(
    `${new Date().getFullYear()}-${
      new Date().getMonth() + 1
    }-${new Date().getDate()}`
  );
  const [totalCredit, setTotalCredit] = useState();
  const [totalDebit, setTotalDebit] = useState();
  const [downloadingData, setDownloadingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getAccountQuickReport = () => {
    setLoading(true);
    const data = {
      accountId,
      startDate: startDate,
      endDate: endDate,
    };
    Account.getAccountQuickReport(data)
      .then((response) => {
        const data = response.data;
        setReports(data);
        const excelData = data.map((item) => ({
          transaction: item.name,
          date: item.date,
          memo: item.memo,
          debit: item.debit,
          credit: item.credit,
        }));
        setDownloadingData(excelData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in Quick Reports", error);
      });
  };
  useEffect(() => {
    getAccountQuickReport();
  }, []);

  return (
    <div class="page-wrapper">
      <div class="content container-fluid">
        <TitleHeader title="Account Quick Report" />
        {loading && (
          <div id="global-loader">
            <div class="whirly-loader"> </div>
          </div>
        )}
        <div class="row">
          <div class="col-sm-12">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <div>
                  Start Date
                  <input
                    className="form-control "
                    type="date"
                    value={startDate}
                    name="start_date"
                    onChange={(val) => setStartDate(val.target.value)}
                  />
                </div>
                <div>
                  End Date
                  <input
                    className="form-control "
                    type="date"
                    value={endDate}
                    name="end_date"
                    onChange={(val) => setEndDate(val.target.value)}
                  />
                </div>
                <div>
                  <br />
                  <a
                    href="#"
                    className="btn btn-secondary"
                    onClick={getAccountQuickReport}
                  >
                    <i class="ion-ios7-search-strong"></i>Search
                  </a>
                </div>
              </div>
              <ExportComponents
                excelData={downloadingData}
                fileName={endDate + "QuickReport.xlsx"}
              />
            </div>
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Transaction</th>
                        <th>Date</th>
                        <th>Memo</th>
                        <th>Debit</th>
                        <th>Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reports?.map((item, index) => {
                        return (
                          <tr>
                            <td>{item.name}</td>
                            <td>{item.date}</td>
                            <td>{item.memo}</td>
                            <td>
                              <USDFigure amount={item.debit} />
                            </td>
                            <td>
                              <USDFigure amount={item.credit} />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td>
                        <strong>
                          <USDFigure
                            amount={reports.reduce(
                              (accumulator, currentObject) => {
                                return accumulator + currentObject.debit;
                              },
                              0
                            )}
                          />
                        </strong>
                      </td>
                      <td>
                        <strong>
                          <USDFigure
                            amount={reports.reduce(
                              (accumulator, currentObject) => {
                                return accumulator + currentObject.credit;
                              },
                              0
                            )}
                          />
                        </strong>
                      </td>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountQuickReport;
